import { render, staticRenderFns } from "./PropertyTableRow.vue?vue&type=template&id=2f9e50d4"
import script from "./PropertyTableRow.vue?vue&type=script&lang=js"
export * from "./PropertyTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports